module.exports = __webpack_public_path__ + "static/media/group--mold--dark.bdea0d70.svg";